export default __webpack_public_path__ + "media/images/features/local_delivery/episode5/LP_03-cf9e7a35d531833e4c180f8eaf068862.jpeg";